import '@/assets/css/init-css.scss';
import './plugins/axios'
import 'element-ui/lib/theme-chalk/index.css';
import 'vant/lib/index.css'
import './plugins/socket'
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import '@/permission' // permission control
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
